import { useClusterTableItems } from "../hooks";
import { ClusterTable } from "./Table";
import ClusterTableAlerts from "./Table/Alerts/ClusterTableAlerts";

const ClustersPage = () => {
  const [clusters, clustersLoading] = useClusterTableItems();

  return (
    <>
      <ClusterTableAlerts clusters={clusters} loading={clustersLoading} />
      <ClusterTable clusters={clusters} loading={clustersLoading} />
    </>
  );
};

export default ClustersPage;
